/* eslint-disable */
import './Spinner.scss';

const Spinner = () => (
  <div className="Spinner">
    {new Array(12).fill().map((_, i) =>
      <div className="Spinner__Ripple" key={i} />
    )}
  </div>
);

export default Spinner;
